module.exports = __webpack_public_path__ + "static/case_droils-e75c91d00aca9b2eccb92ffa13003178.jpg";